import {action} from 'mobx';
import axiosInstance from '~/utils/axiosInstance';
import uris from '~/uris';

class EdgeStore {
  @action('edge password reset')
  edgePasswordReset(data) {
    return axiosInstance.post(uris.edgePasswordReset(), data);
  }

  @action('edge subAdmin create user and add organ')
  edgeUserStructureCreateAndJoin(data) {
    return axiosInstance.post(uris.edgeUserStructureCreateAndJoin(), data);
  }

  @action('edge Admin create user and add organ')
  edgeUserOrganCreateAndJoin(data) {
    return axiosInstance.post(uris.edgeUserOrganCreateAndJoin(), data);
  }

  @action('edge Admin create user and add organ')
  edgeOrganizationAdminCreateAndSet(data) {
    return axiosInstance.post(uris.edgeOrganizationAdminCreateAndSet(), data);
  }
}

export default new EdgeStore();
